import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  signal,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { DocumentService } from '@app/shared/services';
import { Subscription } from 'rxjs';
import { BalanceSubjectService } from './balance-attribute-subject-behavior';
import { AddApiRapidValueService } from '../../../modules/vault/components/add-document/add-api-rapid-value.service';
import { takeUntil, takeWhile } from 'rxjs/operators';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AddEditMotorValueComponent } from '@app/modules/vault/components/add-document/add-api-rapid-motor-value/add-edit-motor-value/add-edit-motor-value.component';
import { AddEditPropertyValueComponent } from '@app/modules/vault/components/add-document/add-api-rapid-property-value/add-edit-property-value/add-edit-property-value.component';
import { EditMxPlayerComponent } from '@app/modules/vault/components/add-document/add-api-key-managed/edit-mx-player/edit-mx-player.component';
import { MxconnectionService } from '@app/shared/services/vault/mxconnection.service';
import { FetchAttributeDataSubject } from '@app/modules/vault/components/add-document/add-finacial-attribute/attribute-subject.service';
import { ConnectToMxComponent } from '@app/modules/vault/mx-component/dialog/connect-to-mx/connect-to-mx.component';
import { MxTaskbarService } from '@app/shared/services/mx-taskbar/mx-taskbar.service';
import { ReportCardNetworthComponent } from '../my-report-container/report-card-networth/report-card-networth.component';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'app-current-balance-card',
  templateUrl: './current-balance-card.component.html',
})
export class CurrentBalanceCardComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  @ViewChild('reportCardNetworth') reportCardNetworth: ReportCardNetworthComponent;
  @Input() attribute:
    | {
        key: string;
        value: any;
        hasFormValues: any;
      }
    | undefined;
  @Input() formData;
  @Output() openFormDialogEmitter: EventEmitter<any> = new EventEmitter();
  @Input() financialAttributes;
  @Input() currentFormId;
  @Input() isRemoveEditSaveSharing;
  @Input() mode;
  @Input() formName = '';
  @Input() templateId = null;
  @Input() selectedFileList = [];
  @Input() connected_to_institution;
  @Input() currentVaultUserId;
  @Input() attribute_type = '';
  balanceData = undefined;
  unstringData;
  @Output() RegisterBalanceComponentEmitter: EventEmitter<any> = new EventEmitter();
  subscription = new Subscription();
  @Input() insuranceAttributes;
  @Input() attributeClasses;
  @Output() balanceDataEmitter: EventEmitter<any> = new EventEmitter();
  @Input() isHighPriorityAttribute = false;
  @Input() currentuserId;
  showChildComponent = true; // Initially render the child component
  displayChildComponent = false; // Control the final display of the child component
  initialized = false;
  connectToMenuLabel = '';
  apiMotorValueList = [];
  isDataFeedConnected = signal(false);
  private addApiRapidPropertyValueService = inject(AddApiRapidValueService);
  private cd = inject(ChangeDetectorRef);
  private _dialog = inject(MatDialog);
  private attributeSubject = inject(FetchAttributeDataSubject);
  private documentService = inject(DocumentService);
  private mxconnectionService = inject(MxconnectionService);
  private balanceDataBehaviorSubject = inject(BalanceSubjectService);
  private mxTaskbarService = inject(MxTaskbarService);
  formType = '';
  screenWidth: number;
  ngOnInit(): void {
    if (!!this.attribute?.value?.live_data_feed) {
      const liveDataFeed = this.attribute?.value?.live_data_feed?.toLowerCase();
      const apiSource = this.attribute?.value?.api_source?.toLowerCase();

      const apiIndicators =
        liveDataFeed === 'zillow' && apiSource === 'zillow'
          ? 'zillow'
          : liveDataFeed === 'vehicle database' && apiSource === 'vehicledatabase'
          ? 'vb'
          : liveDataFeed === 'mx_account_balance' && apiSource === 'mx'
          ? 'mx'
          : '';
      this.addApiRapidPropertyValueService.apiIndicatorsSubjectData.next(apiIndicators);
    }

    this.subscription.add(
      this.balanceDataBehaviorSubject.balanceData.subscribe(() => {
        this.getBalance(this.currentVaultUserId, this.attribute?.value?.vault_form_code);
      })
    );
    this.formType = (this.formData?.type ?? this.formData?.type_template)?.replace(/_/g, ' ');
  }
  ngAfterViewInit(): void {
    this.getDataFeedConnected();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['attribute']) {
      const liveDataFeed = this.attribute?.value?.live_data_feed?.toLowerCase() ?? '';
      const apiSource = this.attribute?.value?.api_source?.toLowerCase();

      const apiIndicators =
        (liveDataFeed === 'zillow' && apiSource === 'zillow') || apiSource === 'zillow'
          ? 'zillow'
          : (liveDataFeed === 'vehicle database' && apiSource === 'vehicledatabase') || apiSource === 'vehicle-database'
          ? 'vb'
          : (liveDataFeed === 'mx_account_balance' && apiSource === 'mx') || apiSource === 'mx'
          ? 'mx'
          : '';
      this.addApiRapidPropertyValueService.apiIndicatorsSubjectData.next(apiIndicators);
      this.getDataFeedConnected();
    }
  }

  getDataFeedConnected() {
    if (!!this.attribute?.value?.live_data_feed) {
      if (this.attribute?.value?.live_data_feed == 'zillow') {
        this.connectToMenuLabel = 'Connect to Zillow';
        this.subscription.add(
          this.addApiRapidPropertyValueService.propertyDataSubjectData.subscribe((data) => {
            !data || data?.length == 0 ? this.isDataFeedConnected.set(false) : this.isDataFeedConnected.set(true);
          })
        );
        this.getVehicleData();
      }
      if (this.attribute?.value?.live_data_feed == 'vehicle database') {
        this.connectToMenuLabel = 'Connect to Vehicle Database';
        this.subscription.add(
          this.addApiRapidPropertyValueService.vehicleDataSubjectData.subscribe((data) => {
            !data || data?.length == 0 ? this.isDataFeedConnected.set(false) : this.isDataFeedConnected.set(true);
          })
        );
        this.getVehicleData();
      }
      if (this.attribute?.value?.live_data_feed == 'mx_account_balance') {
        this.connectToMenuLabel = 'Connect with MX';
        this.subscription.add(
          this.addApiRapidPropertyValueService.mxAccountBalanceSubjectData.subscribe((data) => {
            !data || data?.length == 0 ? this.isDataFeedConnected.set(false) : this.isDataFeedConnected.set(true);
          })
        );
        this.getLinkedMXAccount();
      }
    }
  }
  ngOnDestroy(): void {
    // this.AddApiRapidPropertyValueService.mxAccountBalanceSubjectData.next(null);
    // this.AddApiRapidPropertyValueService.vehicleDataSubjectData.next(null);
    // this.AddApiRapidPropertyValueService.propertyDataSubjectData.next(null);
    this.subscription?.unsubscribe();
  }
  openFormDialog(itemsToSetUp?: boolean | undefined) {
    // console.log("unstringData",this.unstringData);

    if (this.unstringData) {
      !!itemsToSetUp
        ? this.openFormDialogEmitter.emit({ ...this.balanceData, unstringData: this.unstringData, itemsToSetUp })
        : this.openFormDialogEmitter.emit({ ...this.balanceData, unstringData: this.unstringData });
    } else {
      !!itemsToSetUp
        ? this.openFormDialogEmitter.emit({ ...this.balanceData, itemsToSetUp })
        : this.openFormDialogEmitter.emit({ ...this.balanceData });
    }
  }

  convertStringToNumber(input) {
    if (typeof input !== 'string') {
      return input;
    }
    const plainNumber = parseFloat(input.replace(/,/g, ''));
    return plainNumber.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }
  getKeyFromObject(obj: Record<string | number, unknown>) {
    return Object.keys(obj)[0];
  }

  handleRegisterBalanceComponentEmitter(event) {
    this.getBalance(this.currentVaultUserId, this.attribute?.value?.vault_form_code);
    this.RegisterBalanceComponentEmitter.emit(this.attribute?.value?.vault_form_code);
  }

  getAttributeItemValue(input: { title: string; key: string; type: string; default?: string }) {
    if (typeof input?.type === 'string') {
      if (input?.type?.toLowerCase().includes('dollar')) {
        return '$';
      }
      if (input?.type?.toLowerCase().includes('percentage')) {
        return '%';
      }
      if (input?.type?.toLowerCase().includes('assets & liabilities')) {
        return this.attributeClasses?.attribute_sub_class ?? '-';
      }
      if (input?.type?.toLowerCase().includes('income & expense')) {
        return this.attributeClasses?.income_expense_sub_class ?? '-';
      }
      if (input?.default?.toLowerCase() == 'not editable') {
        if (input?.type?.toLowerCase().includes('dollar')) {
          return '$';
        }
        if (input?.type?.toLowerCase().includes('percentage')) {
          return '%';
        }
        if (input?.type?.toLowerCase().includes('Numeric')) {
          return '-';
        }
        if (input?.type?.toLowerCase().includes('input')) {
          return '-';
        }
        if (input?.type?.toLowerCase().includes('assets & liabilities')) {
          return this.attributeClasses?.attribute_sub_class ?? '-';
        }
        if (input?.type?.toLowerCase().includes('income & expense')) {
          return this.attributeClasses?.income_expense_sub_class ?? '-';
        }
        return input?.type;
      }
      return '-';
    }
    return '-';
  }

  getBalance(needToPassCurrntUserId, type?: string) {
    this.subscription.add(
      this.documentService.gatLatestBalance(needToPassCurrntUserId, this.currentFormId, type).subscribe((res) => {
        if (res?.data?.balanceData || res?.data) {
          this.balanceData = undefined;
          this.balanceData = res?.data.balanceData ?? res?.data;
          this.unstringData = undefined;
          this.cd.detectChanges();
          setTimeout(() => {
            this.unstringData = this.convertObjectValuesToNumbers({
              ...JSON.parse(this.balanceData?.additional_data),
              effective_date: this.balanceData?.effective_date ?? '',
              type_class: this.balanceData?.type_class,
            });
            this.balanceDataEmitter.emit({
              ...this.balanceData,
              unstringData: this.unstringData,
              vault_form_code: this.attribute?.value?.vault_form_code,
            });
            // console.log({ balanceData: this.balanceData, unstringData: this.unstringData });
            this.cd.detectChanges();
          }, 70);
        } else {
          this.balanceData = undefined;
          this.unstringData = undefined;
          // console.log({ balanceData: this.balanceData, unstringData: this.unstringData, inputs: this.attribute?.value?.inputs });
          this.cd.detectChanges();
        }
        // this.currentValue = res?.data?.value;
        // this.attributeList = res.data;

        this.cd.detectChanges();
      })
    );
  }
  convertObjectValuesToNumbers(obj) {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
      if (typeof value === 'string' && !isNaN((value as any).replace(/,/g, ''))) {
        result[key] = parseFloat(value.replace(/,/g, ''));
      } else {
        result[key] = value;
      }
    }
    return result;
  }
  getValueFromInput(input) {
    const key = Object.keys(input)[0] as any; // Extract the value of the input object
    const value = this.unstringData[key?.toLowerCase().replace(/\s+/g, '_')]; // Convert key to lowercase and replace spaces with underscores to match the keys in unstringData
    return value ?? null;
  }
  getBalanceFormType(vault_form_code: string) {
    return vault_form_code?.substring(0, 25);
  }
  handleStyleClassForAttributeValues(input: any) {
    if (typeof input?.type === 'string') {
      if (!!input && !!input?.type) {
        if (input?.type == 'Dollar Input') {
          return 'font-bold text-lg text-k-black';
        } else {
          return 'font-semibold text-base text-k-black';
        }
      } else {
        return 'font-semibold text-base text-k-black';
      }
    }
    return 'font-semibold text-base text-k-black';
  }
  showInTemplate(input: any) {
    if (!input?.default) return true;
    if (!!input?.default) {
      if (typeof input?.default == 'string' && input?.default?.toLocaleLowerCase() == "**not shown in 'view' in template") {
        return false;
      } else {
        return true;
      }
    }
    return true;
  }
  convertSwitchBooleanValueToString(value) {
    return value ? 'Yes' : 'No';
  }
  handleValueForSearch(value: string) {
    return value?.split('#')[1];
  }
  handleArrayLengthChange(length: number) {
    this.displayChildComponent = length >= 2;
    this.initialized = true;
  }
  manageLiveDataFeed() {
    if (this.attribute?.value?.live_data_feed == 'zillow') this.addEditPropertyData();
    if (this.attribute?.value?.live_data_feed == 'vehicle database') this.addEditMotorData();
    if (this.attribute?.value?.live_data_feed == 'mx_account_balance') this.addEditMxAccountBalanceData();
  }

  getVehicleData() {
    this.subscription.add(
      this.documentService.getVaultFormRapidIntegration(this.currentFormId).subscribe((res) => {
        this.apiMotorValueList = [];

        if (!res || res?.length == 0) {
          this.addApiRapidPropertyValueService.propertyDataSubjectData.next([]);
          this.addApiRapidPropertyValueService.vehicleDataSubjectData.next([]);
          this.isDataFeedConnected.set(false);
          this.cd.detectChanges();
          return;
        }
        if (res?.length && res.filter((x) => x.type === 'vehicleDatabase')?.length) {
          this.addApiRapidPropertyValueService.vehicleDataSubjectData.next(this.apiMotorValueList);
          const element = res.filter((x) => x.type === 'vehicleDatabase')[0];
          element.payload = JSON.parse(element.payload);
          try {
            element.response = JSON.parse(element.response);
          } catch (error) {}
          element.setting = JSON.parse(element.setting);
          this.apiMotorValueList.push(element);
          this.addApiRapidPropertyValueService.vehicleDataSubjectData.next(this.apiMotorValueList);
          this.addApiRapidPropertyValueService.setPropertyDataFromLiveFeeds(element, this.templateId);
        }
        if (res?.length && res.filter((x) => x.type === 'zillow')?.length) {
          this.addApiRapidPropertyValueService.propertyDataSubjectData.next(this.apiMotorValueList);
          const element = res.filter((x) => x.type === 'zillow')[0];
          element.payload = JSON.parse(element.payload);
          element.response = JSON.parse(element.response);
          element.setting = JSON.parse(element.setting);
          this.apiMotorValueList.push(element);
          this.addApiRapidPropertyValueService.propertyDataSubjectData.next(this.apiMotorValueList);
          this.addApiRapidPropertyValueService.setPropertyDataFromLiveFeeds(element, this.templateId);
        }
        this.cd.detectChanges();
      })
    );
  }

  getLinkedMXAccount() {
    this.subscription.add(
      this.mxconnectionService.getLinkedMXAccount(this.currentFormId).subscribe((res) => {
        this.selectedFileList = [];
        if (!res || res?.length == 0) {
          this.addApiRapidPropertyValueService.mxAccountBalanceSubjectData.next([]);
        }
        if (res) {
          this.selectedFileList.push(res);
          const allConnectedAccounts = this.selectedFileList.filter((item) => item?.connection_status?.toLowerCase() === 'connected');
          // allConnectedAccounts.length > 0 ? this.addApiRapidPropertyValueService.mxAccountBalanceSubjectData.next(allConnectedAccounts) : '';
          this.addApiRapidPropertyValueService.mxAccountBalanceSubjectData.next(allConnectedAccounts);
        }
        this.cd.detectChanges();
      })
    );
  }

  addEditPropertyData() {
    const childDialog = this._dialog.open(AddEditPropertyValueComponent, {
      height: '100%',
      data: {
        currentFormId: this.currentFormId,
        is_edit: this.apiMotorValueList && this.apiMotorValueList.length > 0 ? true : false,
        apiMotorValueList: this.apiMotorValueList,
        templateId: this.templateId,
      },
      panelClass: 'full-window-dialog',
    });
    this.subscription.add(
      childDialog.afterClosed().subscribe(
        (data) => {
          this.addApiRapidPropertyValueService.clearPropertyDataFromGeneralData(this.templateId);
          this.addApiRapidPropertyValueService.copyDataFromLiveFeedsSubjectData.next(true);
          // this.addApiRapidPropertyValueService.addEditPropertySubjectData.next(null);
          // if (data?.success) {
          this.attributeSubject.handleFetchData(true);
          // }
          this.getVehicleData();
        },
        (error) => {
          console.error('Add Edit Property Value Dialog close error:', error);
        }
      )
    );
  }

  addEditMotorData() {
    const childDialog = this._dialog.open(AddEditMotorValueComponent, {
      height: '100%',
      data: {
        currentFormId: this.currentFormId,
        is_edit: this.apiMotorValueList && this.apiMotorValueList.length ? true : false,
        apiMotorValueList: this.apiMotorValueList[0],
        templateId: this.templateId,
      },
      panelClass: 'full-window-dialog',
    });
    this.subscription.add(
      childDialog.afterClosed().subscribe(
        (data) => {
          // eslint-disable-next-line no-console
          this.addApiRapidPropertyValueService.clearPropertyDataFromGeneralData(this.templateId);
          this.addApiRapidPropertyValueService.copyDataFromLiveFeedsSubjectData.next(true);
          // this.addApiRapidPropertyValueService.addEditMotorSubjectData.next(null);
          // if (data?.success) {
          this.attributeSubject.handleFetchData(true);
          // }
          this.getVehicleData();
        },
        (error) => {
          console.error('Add Edit Motor Value Dialog close error:', error);
        }
      )
    );
  }

  addEditMxAccountBalanceData() {
    const childDialog = this._dialog.open(EditMxPlayerComponent, {
      height: '100%',
      data: {
        selectedFileList: this.selectedFileList,
        currentuserId: this.currentVaultUserId,
        currentFormId: this.currentFormId,
        formName: this.formName,
      },
      panelClass: 'full-window-dialog',
    });
    this.subscription.add(
      childDialog.afterClosed().subscribe(
        (data) => {
          this.addApiRapidPropertyValueService.addEditMxAccountBalanceSubjectData.next(null);
          this.getLinkedMXAccount();
        },
        (error) => {
          console.error('Edit MX Player Dialog close error:', error);
        }
      )
    );
  }
  addInstitution() {
    // this.hidePopUp = true;
    const dialogRef: MatDialogRef<ConnectToMxComponent> = this.mxTaskbarService.openMxDialog(ConnectToMxComponent, {
      width: '400px',
      maxWidth: this.screenWidth < 480 ? '90vw' : '80vw',
      autoFocus: false,
      data: {
        formName: this.formName,
        mx_connected_clients: this.selectedFileList,
        title: 'Financial Institution',
        currentFormId: this.currentFormId,
        currentValutUserId: this.currentuserId,
        allowedOne: true,
      },
    });
    this.subscription.add(
      dialogRef.componentInstance.mxDialogMinimized.subscribe((dialogId: string) => {
        this.getDataFeedConnected();
      })
    );
    this.subscription.add(
      dialogRef.afterClosed().subscribe((val) => {
        this.getDataFeedConnected();
        this.getLinkedMXAccount();
        this.cd.detectChanges();
      })
    );
  }
  openBalanceRegister() {
    this.reportCardNetworth.openBalanceRegister();
  }
}
